$(document).on 'turbo:load', ->
  new App.tedDiscussions()

class @App.tedDiscussions
  constructor: ->
    @$rootEl = $('#discuss')
    @bindElements()
    @openDiscussion() if $(".responses").is(":visible")

  bindElements: ->
    $(document).on "ready.discussions", (e) =>
      @bindAutoHeight()

    $(document).on "click.discussions", ".uiToggleSwitch a", (e) =>
      @togglePanels(e)

    $(document).on "click.discussions", ".save-discussion", (e) ->
      e.preventDefault
      $(@).fadeOut(300)
      $('#discuss_panel .success').fadeIn(500).delay(1500).fadeOut(500)

  togglePanels: (e) ->
    panelName = $(e.target).data('panel')
    if panelName is "discussion"
      $("#panels").hide()
      $("#discuss").show()
      $("#discussToggleContent").show()
      $("#standardToggleContent .aboutLesson.non-mobile").hide()
      @openDiscussion()
    else
      $("#panels").show()
      $("#discuss").hide()
      $("#discussToggleContent").hide()
      $("#standardToggleContent .aboutLesson.non-mobile").show()

  bindAutoHeight: ->
    # Recalculate discussion panel height if the content is changed.
    return if @$rootEl.length < 1

    panelObserver = new MutationObserver () => @openDiscussion()
    panelObserver.observe(@$rootEl.get(0), { subtree: true, childList: true })

  # This function recalculates the height of the discussion panel and creates
  # a virtual scrollbox
  openDiscussion: ->
    subtract_height = 0
    height_array = [
      $(".orator"),
      $(".oratorForm"),
      $(".discussHeader"),
      $(".oratorStart")
    ]
    $.each height_array, (i, el) ->
      if el.is(":visible")
        subtract_height = subtract_height + el.height()
    responseHeight = $("#sideRail").height() - subtract_height - 20
    if responseHeight < 500
      responseHeight = 500
    $(".responses").height(responseHeight)
    $("#standardToggleContent .aboutLesson.non-mobile").hide()
